import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';


const AMOUNT_LIMIT = 999999999.00;


function NumberFormatCustom(props) {
    const { inputRef, onChange, id, ...other } = props;
  
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                        id,
                    },
                });
            }}
            isAllowed={(values) => {
                return values.floatValue < AMOUNT_LIMIT
            }}
            id={id}
            thousandSeparator
            allowEmptyFormatting
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
        />
    );
  }

export default class CurrencyInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0
        };
    }

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    render() {
        const { className, label, onChange, id } = this.props;        
        return (
            <div className="currency-field">
                <TextField
                    label={label}
                    className={className}
                    value={this.state.value}                    
                    onBlur={() => {  
                         this.state.value === '' && this.setState({ value : 0.00});
                    }}                    
                    onChange={(e) => {
                        this.setState({ value: e.target.value });
                        e.target.value = Number(e.target.value);
                        onChange(e);
                    }}
                    id={id}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        inputComponent: NumberFormatCustom,
                        id,
                    }}
                />
            </div>
        )
    }
    
}
